import { FC } from 'react';
import { AddCircle as AddCircleIcon } from '@mui/icons-material';
import { Button, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { PageHeader } from '@components/PageHeader';
import { Trans } from '@libs/i18n';

interface AssessmentsHeaderProps {
  onStartNewAssessmentClick: () => void;
}

/**
 * The layout moved to `@components/PageHeader` — nothing about it was
 * assessment-specific and remediation needs the same header. This keeps the
 * assessment-specific copy and the "start new" action.
 */
export const AssessmentsHeader: FC<AssessmentsHeaderProps> = observer(
  ({ onStartNewAssessmentClick }) => {
    const theme = useTheme();

    return (
      <PageHeader
        title={<Trans i18nKey="app.assessments.title" />}
        description={<Trans i18nKey="app.assessments.titleDescription" />}
        action={
          <Button
            variant="contained"
            startIcon={<AddCircleIcon />}
            onClick={onStartNewAssessmentClick}
            sx={{
              borderRadius: 3,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1,
              backgroundColor: theme.palette.secondary.main,
              gap: 1,
              '&:hover': {
                backgroundColor: theme.palette.black[1100],
              },
            }}
          >
            <Trans i18nKey="app.assessments.startNew" />
          </Button>
        }
      />
    );
  },
);
